
import layout from '~/mixins/layout'
/* eslint-disable vue/component-definition-name-casing */
export default {
    name: 'zen',
    mixins: [layout],
}
